/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProceedingParticipantType } from './ProceedingParticipantType';
import {
    ProceedingParticipantTypeFromJSON,
    ProceedingParticipantTypeFromJSONTyped,
    ProceedingParticipantTypeToJSON,
    ProceedingParticipantTypeToJSONTyped,
} from './ProceedingParticipantType';

/**
 * 
 * @export
 * @interface CreateProceedingParticipantRequest
 */
export interface CreateProceedingParticipantRequest {
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof CreateProceedingParticipantRequest
     */
    type: ProceedingParticipantType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProceedingParticipantRequest
     */
    note: string | null;
}



/**
 * Check if a given object implements the CreateProceedingParticipantRequest interface.
 */
export function instanceOfCreateProceedingParticipantRequest(value: object): value is CreateProceedingParticipantRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function CreateProceedingParticipantRequestFromJSON(json: any): CreateProceedingParticipantRequest {
    return CreateProceedingParticipantRequestFromJSONTyped(json, false);
}

export function CreateProceedingParticipantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProceedingParticipantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ProceedingParticipantTypeFromJSON(json['type']),
        'name': json['name'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'country': json['country'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'note': json['note'],
    };
}

export function CreateProceedingParticipantRequestToJSON(json: any): CreateProceedingParticipantRequest {
    return CreateProceedingParticipantRequestToJSONTyped(json, false);
}

export function CreateProceedingParticipantRequestToJSONTyped(value?: CreateProceedingParticipantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ProceedingParticipantTypeToJSON(value['type']),
        'name': value['name'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'note': value['note'],
    };
}

